import { GlobalController } from 'src/shared/global/GlobalController'
import IndustrialIntegrationError from './IndustrialIntegrationError.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'industrial-integration-error',
    name: 'IndustrialIntegrationError',
    component: IndustrialIntegrationError,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
